/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Keyword_MovieInputs */

const en_subtitle_export_keyword_movie = /** @type {(inputs: Subtitle_Export_Keyword_MovieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Movie`)
};

const fr_subtitle_export_keyword_movie = /** @type {(inputs: Subtitle_Export_Keyword_MovieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Film`)
};

const de_subtitle_export_keyword_movie = /** @type {(inputs: Subtitle_Export_Keyword_MovieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Film`)
};

const it_subtitle_export_keyword_movie = /** @type {(inputs: Subtitle_Export_Keyword_MovieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Film`)
};

const ru_subtitle_export_keyword_movie = /** @type {(inputs: Subtitle_Export_Keyword_MovieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фильм`)
};

const es_subtitle_export_keyword_movie = /** @type {(inputs: Subtitle_Export_Keyword_MovieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Película`)
};

const zh_cn2_subtitle_export_keyword_movie = /** @type {(inputs: Subtitle_Export_Keyword_MovieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电影`)
};

const ja_subtitle_export_keyword_movie = /** @type {(inputs: Subtitle_Export_Keyword_MovieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`映画`)
};

const hi_subtitle_export_keyword_movie = /** @type {(inputs: Subtitle_Export_Keyword_MovieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चलचित्र`)
};

const pt_pt2_subtitle_export_keyword_movie = /** @type {(inputs: Subtitle_Export_Keyword_MovieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filme`)
};

/**
* | output |
* | --- |
* | "Movie" |
*
* @param {Subtitle_Export_Keyword_MovieInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_keyword_movie = /** @type {((inputs?: Subtitle_Export_Keyword_MovieInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Keyword_MovieInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_keyword_movie(inputs)
	if (locale === "de") return de_subtitle_export_keyword_movie(inputs)
	if (locale === "it") return it_subtitle_export_keyword_movie(inputs)
	if (locale === "ru") return ru_subtitle_export_keyword_movie(inputs)
	if (locale === "es") return es_subtitle_export_keyword_movie(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_keyword_movie(inputs)
	if (locale === "ja") return ja_subtitle_export_keyword_movie(inputs)
	if (locale === "hi") return hi_subtitle_export_keyword_movie(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_keyword_movie(inputs)
	return en_subtitle_export_keyword_movie(inputs)
});